<section class="contenedorValidacion">  
    <div class="validacion">
      <h2>Detalle de Documentos</h2>
      <table class="tablaDetalles">
        <tr>
          <td class="data">Documento</td>
          <td class="descripcion">
            {{ documento?.nombre }}
          </td>
        </tr>
        <tr>
          <td class="data">Fecha Validez</td>
          <td class="descripcion">
            {{ documento?.fechaValidez | date: 'dd/MM/yyyy' }}
          </td>
        </tr>
        <tr>
          <td class="data">Fecha Caducidad</td>
          <div *ngIf="documento?.fechaCaducidad">
            <td class="descripcion" >{{documento?.fechaCaducidad | date: 'dd/MM/yyyy'}}</td>
          </div>
          <div *ngIf="!documento?.fechaCaducidad">
            <td class="descripcion">No caduca</td>
          </div>
        </tr>
        <tr>
          <td class="data">Fecha de subida</td>
          <td class="descripcion">
            {{ documento?.createdAt | date: 'dd/MM/yyyy' }}
          </td>
        </tr>
      </table>
      <div *ngIf="!documento?.validado" class="descripcion__documento">
        <a  href={{urlDoc}} target="_blank"><img src="../../../../../assets/pendiente-de-validar.svg" class="descripcion__documento"
        #tooltip="matTooltip"  matTooltip="Pendiente de validar" matTooltipPosition="left"/></a>
      </div>
      <div *ngIf="(documento?.enFecha || documento?.noCaduca) && documento?.tipo === 'activo'" class="descripcion__documento">
        <a  href={{urlDoc}} target="_blank"><img  src="../../../../../assets/validado.svg"
        #tooltip="matTooltip"  matTooltip="Validado" matTooltipPosition="left" /></a>
      </div>
      <div *ngIf="documento?.proximoCaduca && documento?.tipo === 'activo'" class="descripcion__documento">
        <a  href={{urlDoc}} target="_blank"><img  src="../../../../../assets/proximo-a-caducar.svg" 
        #tooltip="matTooltip"  matTooltip="Próximo a caducar" matTooltipPosition="left"/></a>
      </div>
      <div *ngIf="documento?.caducado && documento?.tipo === 'activo'" class="descripcion__documento">
        <a  href={{urlDoc}} target="_blank"><img  src="../../../../../assets/caducado.svg" 
        #tooltip="matTooltip"  matTooltip="Caducado" matTooltipPosition="left"/></a>
      </div>
      <div *ngIf="documento?.enFecha && documento?.tipo === 'enEspera'" class="documentos-indicadores1">
        <a  href={{urlDoc}} target="_blank"><img  src="../../../../../assets/verde.png" 
        #tooltip="matTooltip"  matTooltip="Documento nuevo rechazado" matTooltipPosition="left" /></a>
      </div> 
      <div *ngIf="documento?.caducado && documento?.tipo === 'enEspera'" class="documentos-indicadores1">
        <a  href={{urlDoc}} target="_blank"><img  src="../../../../../assets/rojo.png" 
        #tooltip="matTooltip"  matTooltip="Documento nuevo rechazado" matTooltipPosition="left" /></a>
      </div> 
      <div *ngIf="documento?.proximoCaduca && documento?.tipo === 'enEspera'" class="documentos-indicadores1">
        <a  href={{urlDoc}} target="_blank"><img  src="../../../../../assets/Amarillo.png" 
        #tooltip="matTooltip"  matTooltip="Documento nuevo rechazado" matTooltipPosition="left" /></a>
      </div>
    </div>
    <div>
    <h2 class="titulo-coment">Comentarios</h2>
    <div class="comentarios1 displayFlexColumn">
      <div *ngFor="let comentario of comentarios1" class="displayFlexColumn">
        <div class="fecha-coment">
          {{ comentario?.fecha | date: 'dd/MM/yyyy' }}
        </div>
        <div class="fecha-coment">{{ comentario.causa }}</div>
        <div class="comentario">{{ comentario.comentario }}</div>
      </div>
    </div>
  </div>
  <div class="notificaciones2 displayFlexColumn" *ngIf= "documento?.tipo != 'pendiente' && pendiente?.length <= 0">
      <h2>Nuevo Documento</h2>
<form [formGroup]="datosReemplazo" >
  <p>A continuación puedes subir un nuevo documento:</p>
  <div class="docpropia__drop">
      <ngx-file-drop dropZoneClassName="drop" contentClassName="drop_content" dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)" 
      (onFileOver)="fileOver()" (onFileLeave)="fileLeave()">
      <ng-template ngx-file-drop-content-tmp 
          let-openFileSelector="openFileSelector">
          <ng-container *ngIf="nameDocumento">{{nameDocumento}}</ng-container>
          <ng-container *ngIf="!nameDocumento">Puedes soltar aquí los documentos o</ng-container>
          <button type="button" class="boton_drop" (click)="openFileSelector()">Seleccionarlo</button>
      </ng-template>
      </ngx-file-drop>
  </div>
   <div>
      <p>Seleccione la <strong>Fecha de Emisión</strong> y la <strong>Fecha de Caducidad </strong>del nuevo documento:</p>
    <mat-form-field appearance="outline" class="example-form-field">
      <mat-label>Fecha de Emisión</mat-label>
      <input matInput 
          required 
          formControlName="fechaValidez"
          [matDatepicker]="datepicker">
      <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
      <mat-datepicker #datepicker>
        <mat-datepicker-actions>
          <button mat-button matDatepickerCancel>Cancelar</button>
          <button mat-raised-button color="primary" matDatepickerApply>Hecho</button>
        </mat-datepicker-actions>
      </mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="outline" class="example-form-field">
      <mat-label>Fecha de Caducidad</mat-label>
      <input matInput 
          required 
          formControlName="fechaCaducidad"
          [matDatepicker]="datepicker2">
      <mat-datepicker-toggle matSuffix [for]="datepicker2"></mat-datepicker-toggle>
      <mat-datepicker #datepicker2>
        <mat-datepicker-actions>
          <button mat-button matDatepickerCancel>Cancelar</button>
          <button mat-raised-button color="primary" matDatepickerApply >Hecho</button>
        </mat-datepicker-actions>
      </mat-datepicker>
    </mat-form-field>
    <div >
      <div class="radio__caduca">
        <div>
          <input
            type="radio"
            [value]= true
            id="s"
            formControlName="noCaduca"
          />
          <label for="s">No caduca</label>
        </div>
      </div>
    </div>
    <div>
    <button
    class="button__secondary"
    [mat-dialog-close]
    (click)="addDocumento()"
  >
    <img src="../../../../assets/icons-notificar@3x.png" />
    Subir documento y Notificar
  </button>
</div>
    </div>
    
    </form>
    </div>

    <div class="validacion" *ngIf="pendiente?.length > 0 && documento.tipo != 'pendiente'">
      <h2>Detalle de Documentos</h2>
      <table class="tablaDetalles">
        <tr>
          <td class="data">Documento</td>
          <td class="descripcion">
            {{ pendiente[0].nombre }}
          </td>
        </tr>
        <tr>
          <td class="data">Fecha Validez</td>
          <td class="descripcion">
            {{ pendiente[0].fechaValidez | date: 'dd/MM/yyyy' }}
          </td>
        </tr>
        <tr>
          <td class="data">Fecha Caducidad</td>
          <div *ngIf="pendiente[0].fechaCaducidad">
            <td class="descripcion" >{{pendiente[0].fechaCaducidad | date: 'dd/MM/yyyy'}}</td>
          </div>
          <div *ngIf="!pendiente[0].fechaCaducidad">
            <td class="descripcion">No caduca</td>
          </div>
        </tr>
        <tr>
          <td class="data">Fecha de subida</td>
          <td class="descripcion">
            {{ pendiente[0].createdAt | date: 'dd/MM/yyyy' }}
          </td>
        </tr>
      </table>
      <div *ngIf="!pendiente[0].validado" class="descripcion__documento">
        <a  href={{urlDoc}} target="_blank">
        <img src="../../../../../assets/pendiente-de-validar.svg" class="descripcion__documento"
        #tooltip="matTooltip"  matTooltip="Pendiente de validar" matTooltipPosition="left"/></a>
      </div>
    </div>
  </section>
  